//@ts-check
import React from 'react';
import useFormOptions from '../context/useFormOptions';
import useFormDataLayer from '../logic/useFormDataLayer';
import FormField from './Field';
import GoogleMap from '../fields/GoogleMap';
import api from './GoogleMaps';
import Loader from '../controls/Loader';

var ConnectedGoogleMapField = function ConnectedGoogleMapField(_ref) {
  var fieldId = _ref.fieldId,
      xpath = _ref.xpath,
      lookupVisiblity = _ref.lookupVisiblity;
  var fieldData = useFormDataLayer(fieldId);
  var caption = fieldData.caption,
      labelPlacement = fieldData.labelPlacement,
      required = fieldData.required;
  var value = fieldData.value,
      mapType = fieldData.mapType,
      readonly = fieldData.readonly;

  var _useFormOptions = useFormOptions(),
      googleAPIKey = _useFormOptions.googleAPIKey;

  var coordinatesState = api.useCoordinates(googleAPIKey, value);
  var loading = coordinatesState.loading;

  var onChange = function onChange(address) {};

  if (loading) {
    return React.createElement("div", {
      style: {
        height: 400,
        position: 'relative',
        border: '1px solid lightgray'
      }
    }, React.createElement(Loader, null, "Loading address coordinates"));
  }

  return React.createElement(FormField, {
    label: caption,
    labelPlacement: labelPlacement || 'left',
    required: required
  }, React.createElement(GoogleMap, {
    mapType: mapType,
    apiKey: googleAPIKey,
    address: coordinatesState.coordinates,
    readonly: readonly,
    fieldId: fieldId,
    xpath: xpath,
    lookupVisiblity: lookupVisiblity
  }));
};

export default React.memo(ConnectedGoogleMapField);